import { Head, Form, Link } from "@inertiajs/react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, FieldGroup, FieldError, FieldLabel, FieldSet } from "@/components/ui/field";
import H3 from "@/components/ui/h3";

export default function SignIn() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Head title="Sign In" />
      <Form action="/sign_in" method="POST" className="w-full max-w-[380px]">
        {({ errors }) => (
          <FieldSet>
            <H3>Sign In</H3>
            <FieldGroup>
              <Field>
                <FieldLabel htmlFor="sign-up-email">Email</FieldLabel>
                <Input id="sign-up-email" name="email" placeholder="example@email.com" required />
              </Field>

              <Field>
                <FieldLabel htmlFor="password">Password</FieldLabel>
                <Input id="password" type="password" name="password" placeholder="••••••••" required />
              </Field>

              <Field orientation="horizontal">
                <Button type="submit">Sign In</Button>
                {errors.base && (<FieldError>{errors.base}</FieldError>)}
              </Field>

              <p className="text-sm text-muted-foreground">
                Don't have an account?{" "}
                <Link href="/sign_up" className="underline">Sign up</Link>
              </p>
            </FieldGroup>
          </FieldSet>
        )}
      </Form>
    </div>
  );
}
